import { ReactNode, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosError } from "axios";

import { HttpClientContext, X_REQUEST_ID } from "../../../app/client";
import { ConfigItem } from "../../../app/backendTypes";

import ItemCard from "./ItemCard";
import ItemLoader from "./ItemLoader";
import ItemsGrid from "./ItemsGrid";

import Error from "../Error";
import Lost from "../Lost";
import Loading from "../Loading";

function ItemsLoader(props: {
  variant: string;
  render: (config: { kind: string; item: ConfigItem }) => ReactNode;
}) {
  const params = useParams();
  const client = useContext(HttpClientContext);

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<string[]>([]);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    client
      ?.get<string[]>(`/api/${props.variant}`)
      .then((res) => setList(res.data))
      .catch((e: AxiosError) => setError(e.response?.headers[X_REQUEST_ID]))
      .finally(() => setLoading(false));
  }, [client, props.variant]);

  if (loading) return <Loading />;

  if (error) return <Error error={error} />;

  if (!params.item)
    return <ItemsGrid list={list} render={(val) => <ItemCard kind={val} />} />;

  const kind = list.find((value) => value === params.item);

  if (kind)
    return (
      <ItemLoader
        kind={kind}
        variant={props.variant}
        render={(item) => props.render({ kind, item })}
      />
    );

  return <Lost />;
}

export default ItemsLoader;
